if (!customElements.get('mw-brand-flyout')) {
  customElements.define('mw-brand-flyout', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.details = this.querySelector('details');
      this.trigger = this.details.querySelector('summary');
      this.panel = this.querySelector('.mw-brand-flyout__panel');
      this.addEventListener('pointerenter', event => {
        clearTimeout(this.closeTimer);
        if (event.pointerType === 'mouse' && matchMedia('(min-width: 990px) and (hover: hover)').matches) this.open();
      }, options);
      this.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse') this.closeTimer = setTimeout(() => {
          if (!this.contains(document.activeElement)) this.close();
        }, 180);
      }, options);
      this.details.addEventListener('toggle', () => {
        this.trigger.setAttribute('aria-expanded', String(this.details.open));
        if (this.details.open) this.position();
      }, options);
      this.trigger.addEventListener('click', event => {
        if (event.detail > 0 && this.details.open && matchMedia('(hover: hover)').matches) {
          event.preventDefault();
          this.trigger.setAttribute('aria-expanded', 'true');
          return;
        }
        if (!this.details.open) this.closeSiblings();
      }, options);
      this.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (!this.contains(document.activeElement) && !this.matches(':hover')) this.close();
        });
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' && event.target === this.trigger) {
          event.preventDefault();
          this.open();
          this.panel.querySelector('a')?.focus();
        }
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault();
          event.stopPropagation();
          this.close();
          this.trigger.focus();
        }
      }, options);
      this.addEventListener('keyup', event => {
        if (event.key === 'Escape') event.stopPropagation();
      }, options);
      const parent = this.closest('header-menu')?.querySelector('details');
      parent?.addEventListener('toggle', () => {
        if (!parent.open) this.close();
      }, options);
      window.addEventListener('resize', () => {
        if (this.details.open) this.position();
      }, options);
    }
    closeSiblings() {
      this.closest('.header__inline-menu')?.querySelectorAll('mw-brand-flyout').forEach(other => {
        if (other !== this) other.close();
      });
    }
    open() {
      this.closeSiblings();
      this.details.open = true;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.position();
    }
    close() {
      clearTimeout(this.closeTimer);
      this.details.open = false;
      this.trigger.setAttribute('aria-expanded', 'false');
    }
    position() {
      this.removeAttribute('data-side');
      this.style.setProperty('--mw-panel-top', '0px');
      this.panel.style.width = '';
      const anchor = this.getBoundingClientRect();
      const rightSpace = innerWidth - 16 - anchor.right;
      if (rightSpace >= 360) this.panel.style.width = `${Math.min(480, rightSpace)}px`;
      else if (anchor.left >= 376) {
        this.dataset.side = 'left';
        this.panel.style.width = `${Math.min(480, anchor.left - 16)}px`;
      } else this.panel.style.width = `${Math.max(260, rightSpace)}px`;
      const panel = this.panel.getBoundingClientRect();
      const top = Math.max(16 - anchor.top, Math.min(0, innerHeight - 16 - panel.height - anchor.top));
      this.style.setProperty('--mw-panel-top', `${top}px`);
    }
    disconnectedCallback() {
      clearTimeout(this.closeTimer);
      this.controller?.abort();
      this.controller = null;
    }
  });
}
